var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("form-item form-item-box form-item-box-" + _vm.setStype)},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"wrap-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }